/**
 * Money formatting for the school-order surfaces. Pure + testable.
 */

/** Format integer cents as a currency string (falls back gracefully). */
export function formatCents(cents: number, currency = 'USD'): string {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100)
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`
  }
}

/**
 * A menu item's displayable per-unit price, or null when there is nothing
 * meaningful to show: UNPRICED items (no tier matched), missing cents, and
 * deliberate $0 items all render no price — the same semantics the family
 * surface uses.
 */
export function itemPriceLabel(item: {
  isPriced?: boolean
  customerPriceCents: number | null
  currency: string | null
}): string | null {
  if (item.isPriced === false || item.customerPriceCents == null || item.customerPriceCents <= 0) {
    return null
  }
  return formatCents(item.customerPriceCents, item.currency ?? 'USD')
}
